import store from "../store/index";
import ApiHelpers from "../helpers/ApiHelpers";
import {
  CERTIFICATE_API,
  CERTIFICATE_USERS_API,
  CERTIFICATE_USERS_EXPORT_API,
 
} from "../constants/urls";

export const certificateService = {
  fetchCertificateByID,
  fetchCertificates,
  addCertificate,
  updateCertificate,
  deleteCertificate,
  fetchCurrentUserCertificates,
  fetchUserCertificates,
  revokeUserCertificate,
  exportUserCertificates,
};

async function fetchCertificateByID(id) {
  const response = await ApiHelpers.makeAPICall(
    `${store.state.appState.apiURL}${CERTIFICATE_API}/${id}`,
    "GET",
    null,
    false
  );
 
  return await handleResponse(response);
}

async function fetchCertificates() {
  const url = `${store.state.appState.apiURL}${CERTIFICATE_API}`;
  const response = await ApiHelpers.makeAPICall(url, "GET", null, false);
  return await handleResponse(response);
}

async function addCertificate(certificateData) {
  const response = await ApiHelpers.makeAPICall(
    `${store.state.appState.apiURL}${CERTIFICATE_API}`,
    "POST",
    JSON.stringify(certificateData),
    true
  );
  return await handleResponse(response);
}

async function updateCertificate(certificateData) {
  const response = await ApiHelpers.makeAPICall(
    `${store.state.appState.apiURL}${CERTIFICATE_API}`,
    "PUT",
    JSON.stringify(certificateData),
    true
  );
  return await handleResponse(response);
}

async function deleteCertificate(id) {
  const response = await ApiHelpers.makeAPICall(
    `${store.state.appState.apiURL}${CERTIFICATE_API}/${id}`,
    "DELETE",
    null,
    false
  );

  return await handleResponse(response);
}

async function fetchCurrentUserCertificates() {
  const url = `${store.state.appState.apiURL}${CERTIFICATE_API}/me`;
  const response = await ApiHelpers.makeAPICall(url, "GET", null, false);
  return await handleResponse(response);
}

async function fetchUserCertificates({ nextPageToken = null, searchQuery = null, isNewestFirst = true, certificateIds = null, startDate = null, endDate = null, pageSize = 25 } = {}) {
    const queryParams = new URLSearchParams();
    if (searchQuery) queryParams.append("SearchQuery", searchQuery);
    if (nextPageToken) queryParams.append("NextPageToken", nextPageToken);

    if (certificateIds && certificateIds.length) {
      certificateIds.forEach(id => queryParams.append("CertificateIDs", id));
    }

    if (startDate) queryParams.append("StartDate", startDate);
    if (endDate) queryParams.append("EndDate", endDate);
     
    queryParams.append("IsNewestFirst", isNewestFirst);
    queryParams.append("PageSize", pageSize);

    const apiUrl = `${store.state.appState.apiURL}${CERTIFICATE_USERS_API}?${queryParams.toString()}`;
    const response = await ApiHelpers.makeAPICall(apiUrl, 'GET', null, false);
    const responseData = await response?.json()
    
    if (!response.ok || responseData?.error) {
      const error = responseData?.error || { message: "Failed to fetch user certificates." };
      return Promise.reject(error);
    }

    return responseData;
  }

  async function revokeUserCertificate(id) {
    const response = await ApiHelpers.makeAPICall(
      `${store.state.appState.apiURL}${CERTIFICATE_USERS_API}/revoke/${id}`,
      "POST",
      null,
      true
    );
    return await handleResponse(response);
  }

  async function exportUserCertificates({ searchQuery = null, certificateIds = null, startDate = null, endDate = null } = {}) {
    const queryParams = new URLSearchParams();
    if (searchQuery) queryParams.append("SearchQuery", searchQuery);
        
    if (certificateIds && certificateIds.length) {
        certificateIds.forEach(id => queryParams.append("CertificateIDs", id));
    }

    if (startDate) queryParams.append("StartDate", startDate);
    if (endDate) queryParams.append("EndDate", endDate);

    const url = `${store.state.appState.apiURL}${CERTIFICATE_USERS_EXPORT_API}?${queryParams.toString()}`;

    const response = await ApiHelpers.makeAPICall(url,"GET",null, false);

    await handleExportErrorResponse(response);

    const blob = await response.blob();
    const fileName = `certificates_${new Date().toISOString().slice(0, 10)}.csv`; 
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName; 
    document.body.appendChild(link);
    link.click(); 
    document.body.removeChild(link);
}

async function handleExportErrorResponse(response) {
    if (!response.ok) {
      let message = `Export failed with status ${response.status}`;
  
      const contentType = response.headers.get("content-type") || "";
      if (contentType.includes("application/json")) {
        const errorBody = await response.json();
        if (errorBody?.error?.message) {
          message = errorBody.error.message;
        }
      }
  
      return Promise.reject({ status: response.status, ok: false, message });
    }
  
    return response; 
}

async function handleResponse(response) {
    try {
        const text = await response.text(); 
        const body = text ? JSON.parse(text) : null; 

        if (body?.status?.toLowerCase() === 'success') {
            return body.payload;
        } else {
            return Promise.reject(body.error || { message: 'Some error occured. '});
        }
    } catch (error) {
        return Promise.reject({ message: 'Some error occured. '})
    }
}